import { useRef } from "react";
import getLessonColor from "../getLessonColor";
import constants from "../constants";
import { PersonIcon } from "./icons/PersonIcon";
import { LocationIcon } from "./icons/LocationIcon";
import { useHiddenLessons } from "../customHooks/useHiddenLessons";

const iconSize = 15;

const MobileTimetableLesson = ({ lessonInfo, current }) => {
    const { isLessonHidden, toggleLessonVisibility } = useHiddenLessons();
    const isHidden = isLessonHidden(lessonInfo.lessonId);
	
	const startTime = lessonInfo.StartDateTime.tz(constants.curTimezone).format("k:mm");
	const endTime = lessonInfo.EndDateTime.tz(constants.curTimezone).format("k:mm");

	let room = lessonInfo.Location;
	let roomDetailed = [""];

	if (room !== null) {
		let splitPos = room.search(" ");
		if (splitPos !== -1) {
			roomDetailed = room.slice(splitPos);
			room = room.slice(0, splitPos);
		}
	}

	let rooms = [];
	rooms.push({ location: room, locationDetails: roomDetailed });

	if (lessonInfo.Locations !== undefined) {
		rooms = lessonInfo.Locations.map((el) => {
			let room = el.location;
			let roomDetailed = [""];

			if (room !== null) {
				let splitPos = room.search(" ");
				if (splitPos !== -1) {
					roomDetailed = room.slice(splitPos);
					room = room.slice(0, splitPos);
				}
			}

			return {
				nameSpecification: el.nameSpecification,
				location: room,
				locationDetails: roomDetailed,
				staffName: el.staffName,
			};
		});
	}

	let groupSpecification = null;
	if (rooms.length === 1 && lessonInfo.Name) {
		const nameParts = lessonInfo.Name.split("/");
		const lastPart = nameParts[nameParts.length - 1];
		if (lastPart && !lastPart.toLowerCase().includes("sem")) {
			groupSpecification = lastPart;
		}
	}

    const handleDoubleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleLessonVisibility(lessonInfo.lessonId);
    };

    // Mobile double-tap detection with movement guard
    const lastTapRef = useRef(0);
    const touchStartPosRef = useRef({ x: 0, y: 0 });
    const TOUCH_TIME_MS = 300;
    const MOVE_TOLERANCE_PX = 12;

    const handleTouchStart = (e) => {
        if (e.touches && e.touches.length > 0) {
            const t = e.touches[0];
            touchStartPosRef.current = { x: t.clientX, y: t.clientY };
        }
    };

    const handleTouchEnd = (e) => {
        const t = e.changedTouches && e.changedTouches[0];
        if (t) {
            const dx = t.clientX - touchStartPosRef.current.x;
            const dy = t.clientY - touchStartPosRef.current.y;
            const moved = Math.hypot(dx, dy) > MOVE_TOLERANCE_PX;
            if (moved) return; // treat as scroll/drag
        }

        const now = Date.now();
        const isDoubleTap = lastTapRef.current && now - lastTapRef.current < TOUCH_TIME_MS;
        lastTapRef.current = now;
        if (!isDoubleTap) return; // first tap only, do nothing

        e.preventDefault();
        e.stopPropagation();
        toggleLessonVisibility(lessonInfo.lessonId);
    };

	return (
		<div
            className={"mobile-lesson" + (current ? " current" : "") + (isHidden ? " hidden-lesson" : "")}
            style={{ "--type-color": getLessonColor(lessonInfo.EventType) }}
            onDoubleClick={handleDoubleClick}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
		>
			<div className="lesson-type-grid-item">
				{lessonInfo.EventType && (
					<p className="lesson-type lesson-type-grid-item">{lessonInfo.EventType}</p>
				)}
			</div>

			<div className="times">
				<p> {startTime}</p>
				<p> {endTime}</p>
			</div>

			<div className="mobile-lesson-content">
				<h3 className="lesson-heading">
					{lessonInfo.Description +
						(groupSpecification ? ` (${groupSpecification})` : "")}
				</h3>
				<p className="lesson-long-name"> {lessonInfo.Name} </p>

				{rooms.length === 1 && lessonInfo.staffName && (
					<div className="lesson-staff">
						<div>
							<PersonIcon width={iconSize} height={iconSize} />
						</div>
						<span>{lessonInfo.staffName}</span>
					</div>
				)}

				<div className="lesson-rooms-wrapper">
					<div>
						<LocationIcon width={iconSize} height={iconSize} />
					</div>
					<div className="lesson-rooms">
						{rooms.map((room, ind) => {
							return (
								<div key={ind}>
									<div className="lesson-room">
										<div>
											<span className="lesson-room-name">
												{room.nameSpecification &&
													room.nameSpecification + " — "}
												{room.location}
											</span>{" "}
											{room.staffName && <>({room.staffName})</>}
										</div>
									</div>
									{/* <p className="lesson-detailed-room"> { room.locationDetails && room.locationDetails } </p> */}
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};

export default MobileTimetableLesson;
